import { Divider, makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import CannedTipsButtons from './CannedTipsButtons.jsx';
import NumericTipsInput from './NumericTipsInput.jsx';

export default Tips;

const useStyles = makeStyles({
  container: {
    width: '100%',
    backgroundColor: '#ffffff',
    border: '1px solid #E1E1E1',
    borderRadius: 10,
    textAlign: 'center',
    marginTop: 20,
  },
  description: {
    margin: '20px 0 15px',
    width: '100%',
  },
  divider: {
    marginBottom: 0,
  },
});

function Tips() {
  const classes = useStyles();
  return (
    <Grid className={classes.container}>
      <Typography variant='subtitle2' className={classes.description}>
        Support your driver (100% goes to driver)
      </Typography>
      <Divider className={classes.divider} />
      <CannedTipsButtons />
      <NumericTipsInput />
    </Grid>
  );
}
